module.exports = __webpack_public_path__ + "img/制御工学3_5.b705d474.png";